import { useDict } from '../../i18n/dictionary';
import { api } from '../../lib/api';
import {
  useCreateResource,
  useDeleteResource,
  useResourceQuery,
  useUpdateResource,
} from '../../lib/crud';
import { adminDict } from './i18n';

// User counts feed the overview, so every mutation invalidates both.
const ADMIN = ['admin'] as const;

export function useAdminOverview() {
  const t = useDict(adminDict);
  return useResourceQuery(
    [...ADMIN, 'overview'],
    api.admin.overview,
    t.loadOverviewFailed,
  );
}

export function useUsers() {
  const t = useDict(adminDict);
  return useResourceQuery(
    [...ADMIN, 'users'],
    api.admin.listUsers,
    t.loadUsersFailed,
  );
}

export function useCreateUser() {
  const t = useDict(adminDict);
  return useCreateResource(ADMIN, api.admin.createUser, t.createUserFailed);
}

/** Grants are replaced wholesale, so this is an update addressed by user id. */
export function useSetAccess() {
  const t = useDict(adminDict);
  return useUpdateResource(
    ADMIN,
    api.admin.setAccess,
    t.saveAccessFailed,
    t.accessSaved,
  );
}

export function useDeleteUser() {
  const t = useDict(adminDict);
  return useDeleteResource(ADMIN, api.admin.deleteUser, t.deleteUserFailed);
}
